// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { store } from './store/Store';
import Spinner from './views/spinner/Spinner';
import './utils/i18n';
import './assets/style/mui-overwrite.scss';
import { CookiesProvider } from 'react-cookie';

if (import.meta.env.MODE === 'dash') {
  // Silence all console methods
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
  console.info = () => { };
  console.debug = () => { };
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <Provider store={store}>
    <Suspense fallback={
      <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        <Spinner sx={{ maxWidth: '50px', maxHeight: '50px' }} />
      </div>}>
      <BrowserRouter>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </BrowserRouter>
    </Suspense>
  </Provider>,
);
